/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFilesContent } from "../../funcs/llmFilesContent.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetFileContentRequest$inboundSchema,
};

export const tool$llmFilesContent: ToolDefinition<typeof args> = {
  name: "llm-files-content",
  description: `Retrieve file content

Returns the raw binary contents of the specified file with appropriate Content-Type header.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFilesContent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
